<template>
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
  >
    <path d="M2.5 1H3.25V5.74704C3.25 6.15896 3.14821 6.5645 2.95369 6.9276L0.347954 11.7916C-0.187362 12.7909 0.536566 13.9999 1.67017 13.9999H10.3298C11.4634 13.9999 12.1874 12.7909 11.652 11.7916L9.0463 6.9276C8.85178 6.5645 8.75 6.15896 8.75 5.74704V1H9.5C9.77614 1 10 0.776142 10 0.5C10 0.223858 9.77614 0 9.5 0H2.5C2.22386 0 2 0.223858 2 0.5C2 0.776142 2.22386 1 2.5 1ZM4.25 5.74704V1H7.75V5.74704C7.75 6.32373 7.89249 6.89149 8.16482 7.39983L8.7542 8.5H3.24579L3.83517 7.39983C4.1075 6.89149 4.25 6.32373 4.25 5.74704ZM2.71007 9.5H9.28992L10.7706 12.2638C10.949 12.5969 10.7077 12.9999 10.3298 12.9999H1.67017C1.2923 12.9999 1.05099 12.5969 1.22943 12.2638L2.71007 9.5Z" />
  </svg>
</template>
